<template>
  <div>
    <form-field-currency
      label="After Repair Value"
      v-model="form.after_repair_value"
      :validation-errors="validationErrors.after_repair_value"
    ></form-field-currency>

    <form-field-currency
      label="Repair Costs"
      v-model="form.repair_costs"
      :validation-errors="validationErrors.repair_costs"
    ></form-field-currency>

    <form-field-currency
      label="Monthly Holding Costs"
      v-model="form.holding_costs"
      :validation-errors="validationErrors.holding_costs"
    ></form-field-currency>

    <form-field-input
      label="Number of Months"
      v-model="form.holding_time"
      type="number"
      :validation-errors="validationErrors.holding_time"
    >
      <template v-slot:after>
        <p class="control">
          <span class="button is-small field-button">months</span>
        </p>
      </template>
    </form-field-input>

    <form-field-currency
      label="Other Costs"
      v-model="form.other_costs"
      :validation-errors="validationErrors.other_costs"
    ></form-field-currency>

    <form-field-currency
      label="Desired Profit"
      v-model="form.desired_profit"
      :validation-errors="validationErrors.desired_profit"
    ></form-field-currency>

    <hr>

    <p class="mao_value">Max Allowable Offer <span>{{ $utils.formatCurrency(maxAllowableOffer, 0) }}</span></p>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "FlipAnalysisForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
          record_id: this.$store.state.activeRecord.record.id,
          after_repair_value: '',
          repair_costs: '',
          holding_costs: '',
          holding_time: '',
          other_costs: '',
          desired_profit: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = (this.formData && this.formData.id) ? this.$utils.clone(this.formData) : this.$utils.clone({...this.defaultForm, ...this.formData});
    },
    computed: {
      worth() {
        // these are null by default instead of 0 so the UI is easier to use, but for calculations I need them to be 0
        let afterRepairValue = this.form.after_repair_value ? this.form.after_repair_value : 0;
        let repairCosts = this.form.repair_costs ? this.form.repair_costs : 0;
        let otherCosts = this.form.other_costs ? this.form.other_costs : 0;
        let holdingCosts = this.form.holding_costs ? this.form.holding_costs : 0;
        let holdingTime = this.form.holding_time ? this.form.holding_time : 0;

        const holdingCostsCalculated = parseFloat(holdingCosts) * parseFloat(holdingTime);
        const totalCosts = parseFloat(repairCosts) + holdingCostsCalculated + parseFloat(otherCosts);

        return parseFloat(afterRepairValue) - totalCosts;
      },
      maxAllowableOffer() {
        let desiredProfit = this.form.desired_profit ? this.form.desired_profit : 0;

        return this.worth - parseFloat(desiredProfit);
      },
    },
    methods: {
      update() {
        this.form.maximum_allowable_offer = this.maxAllowableOffer;

        return this.$api.analysis.updateFixAndFlipAnalyses(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Analysis was updated',
              type: 'is-success'
            });

            return res;
          })
        },
      create() {
        this.form.maximum_allowable_offer = this.maxAllowableOffer;

        return this.$api.analysis.createFixAndFlipAnalyses(this.form)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Analysis was created',
              type: 'is-success'
            });

            return res;
          })
        },
      // delete() {
      //   return this.$api.fixAndFlipAnalyses.delete(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'FixAndFlipAnalysi was archived',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
      // restore() {
      //   return this.$api.fixAndFlipAnalyses.restore(this.form.id)
      //     .then(res => {
      //       this.$buefy.toast.open({
      //         message: 'FixAndFlipAnalysi was restored',
      //         type: 'is-success'
      //       });
      //
      //       return res;
      //     });
      // },
    },
  }
</script>

<style lang="scss" scoped>
@import "../styles/variables/variables";

.mao_value {
  span {
    float: right;
  }
}
</style>
